export const AUTHENTICATION_STATUS = {
  LOADING: "Loading",
  AUTHENTICATED: "Authenticated",
  NOT_AUTHENTICATED: "Not-Authenticated",
}
